<template>
  <div class="row">
    <div class="col-lg-12">
      <modal :show.sync="modals.failedModal">
        <div
          class="modal-header"
          style="
            margin: -25px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #EC1B23;
            text-align: center;
          "
        >
          <div class="col-lg-12">
            <div>
              <i
                style="color: white; font-size: 120px; font-weight: 900"
                class="tim-icons icon-alert-circle-exc"
              ></i>
            </div>
            <div>
              <p
                style="
                  color: white;
                  font-size: 17px;
                  text-align: center;
                  font-weight: 500;
                "
              >
                Failed
              </p>
            </div>
          </div>
          <div class="col-lg"></div>
        </div>
        <div class="col-lg-12 text-center">
          <p
            style="
              margin-top: 50px;
              font-size: 40px;
              font-weight: 500;
              color: #707070;
            "
          >
            Warning!
          </p>

          <p style="color: #A5A5A5">{{ message }}</p>

          <div class="col-lg-12 text-center" style="margin-bottom: 50px">
            <base-button type="danger" v-on:click="modals.failedModal = false"
              >Cancel</base-button
            >&nbsp;
          </div>
        </div>
      </modal>
      <StatusModal
        :show.sync="modals.successModal"
        :message="modal.success"
        :title="modal.successTitle"
      />
      <modal
        :show.sync="modals.addnewpriceentry"
        class="modal-eprf-small"
        centered
      >
        <b-card
          class="card text-center"
          style="background-color: #f5f6fa; box-shadow: none"
          border-variant="primary"
          header="REASON FOR DISPUTE"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <template #header>
            <div class="row" style="margin-bottom: 10px">
              <div class="col-lg text-center">
                <h4 class="mb-0">
                  <span v-if="flag == 'add'">CREATE</span
                  ><span v-if="flag == 'edit'">EDIT</span> PRICE RATE
                </h4>
              </div>
              <div
                class=""
                style="
                  position: absolute;
                  top: 0;
                  right: 0;
                  padding-right: 10px;
                  padding-top: 5px;
                "
              >
                <base-button class="btn-icon btn-cancel btn-round btn-sm">
                  <i
                    style="color: white; font-weight: 900; font-size: 12px"
                    class="tim-icons icon-simple-remove"
                    @click="modals.addnewpriceentry = false"
                  ></i>
                </base-button>
              </div>
            </div>
          </template>

          <div class="row">
            <div class="col-lg text-left">
              <p style="color: #A5A5A5; font-size: 14px">Item</p>
              <el-select
                class="select-info"
                placeholder="Select Item"
                v-model="pricerate.item"
                style="width: 95%; border-bottom: 1px solid lightgray"
                v-if="flag == 'add'"
                filterable
              >
                <el-option
                  v-for="option in pricerate.items"
                  class="select-info"
                  :value="option.value"
                  :label="option.label"
                  :key="option.value"
                ></el-option>
              </el-select>
              <p
                style="
                  color: #707070;
                  font-size: 15px;
                  border-bottom: 1px solid lightgray;
                "
                v-if="flag == 'edit'"
              >
                {{ pricerate.item }}
              </p>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-lg text-left">
              <p style="color: #A5A5A5; font-size: 14px">Description</p>
              <div>
                <input
                  type="text"
                  v-model="pricerate.description"
                  :class="{ 'custom-input': true }"
                  disabled
                />
              </div>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-lg text-left">
              <p style="color: #A5A5A5; font-size: 14px">Price/kg (RM)</p>
              <div>
                <input
                  type="number"
                  :min="0"
                  v-model="pricerate.price"
                  :class="{ 'custom-input': true }"
                  step="0.01"
                />
              </div>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-lg text-right">
              <base-button class="btn-primary" @click="submitPriceRate()"
                >Save</base-button
              >
            </div>
          </div>
        </b-card>
      </modal>
      <modal
        :show.sync="modals.addconcessionprice"
        class="modal-eprf-small"
        centered
      >
        <b-card
          class="card text-center"
          style="background-color: #f5f6fa; box-shadow: none"
          border-variant="primary"
          header="REASON FOR DISPUTE"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <template #header>
            <div class="row" style="margin-bottom: 10px">
              <div class="col-lg text-center">
                <h4 class="mb-0">
                  <span v-if="flag == 'add'">CREATE</span
                  ><span v-if="flag == 'edit'">EDIT</span> CONCESSION PRICE
                  ENTRY
                </h4>
              </div>
              <div
                class=""
                style="
                  position: absolute;
                  top: 0;
                  right: 0;
                  padding-right: 10px;
                  padding-top: 5px;
                "
              >
                <base-button class="btn-icon btn-cancel btn-round btn-sm">
                  <i
                    style="color: white; font-weight: 900; font-size: 12px"
                    class="tim-icons icon-simple-remove"
                    @click="modals.addconcessionprice = false"
                  ></i>
                </base-button>
              </div>
            </div>
          </template>
          <div class="row">
            <div class="col-lg text-left">
              <p style="color: #A5A5A5; font-size: 14px">Customer</p>
              <el-select
                v-if="flag == 'add'"
                class="select-info"
                placeholder="Select Customer"
                v-model="concessionprice.customer"
                style="width: 95%; border-bottom: 1px solid lightgray"
                filterable
              >
                <el-option
                  v-for="option in concessionprice.customers"
                  class="select-info"
                  :value="option.value"
                  :label="option.label"
                  :key="option.value"
                ></el-option>
              </el-select>
              <input
                v-if="flag == 'edit'"
                type="text"
                v-model="concessionprice.customer"
                :class="{ 'custom-input': true }"
                disabled
              />
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-lg">
              <el-table
                :data="concessionprice.wastetypes"
                :header-cell-style="{
                  border: 'transparent',
                  'font-size': '14px',
                  'font-weight': '600',
                  'background-color': '#358DCC',

                  color: '#FFFFFF',
                }"
                style="
                  border-top-right-radius: 5px;
                  border-top-left-radius: 5px;
                "
                :cell-style="{
                  fontColor: '#707070',
                  border: 'transparent',
                  'font-size': '14px',
                }"
              >
                <el-table-column label="No" minWidth="30" align="center">
                  <div slot-scope="scope">
                    {{ scope.$index + 1 }}
                  </div>
                </el-table-column>
                <el-table-column label="Waste Type">
                  <div slot-scope="{ row }">
                    <el-select
                      class="select-info"
                      placeholder="Select Customer"
                      v-model="row.wastetype"
                      style="width: 95%; border-bottom: 1px solid lightgray"
                      filterable
                    >
                      <el-option
                        v-for="option in wastesubtypes"
                        class="select-info"
                        :value="option.value"
                        :label="option.label"
                        :key="option.value"
                      ></el-option>
                    </el-select>
                  </div>
                </el-table-column>
                <el-table-column label="Price/kg(RM)" prop="price" width="150">
                  <div slot-scope="{ row }">
                    <input
                      type="number"
                      :min="0"
                      v-model="row.price"
                      :class="{ 'custom-input': true }"
                      step="0.01"
                    />
                  </div>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="row">
            <div class="col-lg text-left">
              <base-button
                class="btn-link btn-primary"
                @click="addrow('concession')"
                >+ Add row</base-button
              >
            </div>
          </div>
          <div class="row">
            <div class="col-lg text-left">
              <p style="color: #A5A5A5; font-size: 14px">Concession Expiry Date</p>
              <div>
                <el-date-picker
                  v-model="concessionprice.expirydate"
                  placeholder="Select date"
                ></el-date-picker>
              </div>
            </div>
          </div>

          <br />
          <div class="row">
            <div class="col-lg text-right">
              <base-button class="btn-primary" @click="submitConcession()"
                >Save</base-button
              >
            </div>
          </div>
        </b-card>
      </modal>
      <modal
        :show.sync="modals.addInventoryMgmt"
        class="modal-eprf-small"
        centered
      >
        <b-card
          class="card text-center"
          style="background-color: #f5f6fa; box-shadow: none"
          border-variant="primary"
          header="REASON FOR DISPUTE"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <template #header>
            <div class="row" style="margin-bottom: 10px">
              <div class="col-lg text-center">
                <h4 class="mb-0">
                  <span v-if="flag == 'add'">CREATE</span
                  ><span v-if="flag == 'edit'">EDIT</span> INVENTORY ITEM
                </h4>
              </div>
              <div
                class=""
                style="
                  position: absolute;
                  top: 0;
                  right: 0;
                  padding-right: 10px;
                  padding-top: 5px;
                "
              >
                <base-button class="btn-icon btn-cancel btn-round btn-sm">
                  <i
                    style="color: white; font-weight: 900; font-size: 12px"
                    class="tim-icons icon-simple-remove"
                    @click="modals.addInventoryMgmt = false"
                  ></i>
                </base-button>
              </div>
            </div>
          </template>

          <div class="row">
            <div class="col-lg text-left">
              <p style="color: #A5A5A5; font-size: 14px">Waste Type</p>
              <div>
                <el-select
                  class="select-info"
                  placeholder="Select Waste type"
                  v-model="inventory.wastetype"
                  style="width: 95%; border-bottom: 1px solid lightgray"
                  filterable
                >
                  <el-option
                    v-for="option in wastetypes"
                    class="select-info"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg text-left">
              <p style="color: #A5A5A5; font-size: 14px">Item</p>
              <div>
                <input
                  type="text"
                  v-model="inventory.item"
                  :class="{ 'custom-input': true }"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg text-left">
              <p style="color: #A5A5A5; font-size: 14px">Description</p>
              <div>
                <input
                  type="text"
                  v-model="inventory.description"
                  :class="{ 'custom-input': true }"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg text-left">
              <p style="color: #A5A5A5; font-size: 14px">Service Location</p>
              <div>
                <el-select
                  class="select-info"
                  placeholder="Select Service Location"
                  v-model="inventory.servicelocation"
                  style="width: 95%; border-bottom: 1px solid lightgray"
                  filterable
                >
                  <el-option
                    v-for="option in servicelocations"
                    class="select-info"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg text-left">
              <p style="color: #A5A5A5; font-size: 14px">Show / hide</p>
              <div>
                <input
                  type="radio"
                  id="show"
                  value="Show"
                  v-model="inventory.isShow"
                />
                <label for="show" style="color: #A5A5A5; font-size: 14px">
                  &nbsp;&nbsp;&nbsp; Show</label
                >

                &nbsp;<input
                  type="radio"
                  id="hide"
                  value="Hide"
                  v-model="inventory.isShow"
                />
                <label for="hide" style="color: #A5A5A5; font-size: 14px">
                  &nbsp;&nbsp;&nbsp; Hide</label
                >
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg text-left">
              <p style="color: #A5A5A5; font-size: 14px">Show in Pre-processing</p>
              <div>
                <input
                  type="radio"
                  id="show"
                  value="Show"
                  v-model="inventory.isShowPreprocessing"
                />
                <label for="show" style="color: #A5A5A5; font-size: 14px">
                  &nbsp;&nbsp;&nbsp; Show</label
                >

                &nbsp;<input
                  type="radio"
                  id="hide"
                  value="Hide"
                  v-model="inventory.isShowPreprocessing"
                />
                <label for="hide" style="color: #A5A5A5; font-size: 14px">
                  &nbsp;&nbsp;&nbsp; Hide</label
                >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg text-left">
              <p style="color: #A5A5A5; font-size: 14px">
                Show in Post-processing
              </p>
              <div>
                <input
                  type="radio"
                  id="show"
                  value="Show"
                  v-model="inventory.isShowPostprocessing"
                />
                <label for="show" style="color: #A5A5A5; font-size: 14px">
                  &nbsp;&nbsp;&nbsp; Show</label
                >

                &nbsp;<input
                  type="radio"
                  id="hide"
                  value="Hide"
                  v-model="inventory.isShowPostprocessing"
                />
                <label for="hide" style="color: #A5A5A5; font-size: 14px">
                  &nbsp;&nbsp;&nbsp; Hide</label
                >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg text-left">
              <p style="color: #A5A5A5; font-size: 14px">Sellable product?</p>
              <div>
                <input
                  type="radio"
                  id="show"
                  value="Yes"
                  v-model="inventory.isSellableProduct"
                />
                <label for="show" style="color: #A5A5A5; font-size: 14px">
                  &nbsp;&nbsp;&nbsp; Yes</label
                >

                &nbsp;<input
                  type="radio"
                  id="hide"
                  value="No"
                  v-model="inventory.isSellableProduct"
                />
                <label for="hide" style="color: #A5A5A5; font-size: 14px">
                  &nbsp;&nbsp;&nbsp; No</label
                >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg text-left">
              <p style="color: #A5A5A5; font-size: 14px">Corrosive product?</p>
              <div>
                <input
                  type="radio"
                  id="show"
                  value="Yes"
                  v-model="inventory.isCorrosive"
                />
                <label for="show" style="color: #A5A5A5; font-size: 14px">
                  &nbsp;&nbsp;&nbsp; Yes</label
                >

                &nbsp;<input
                  type="radio"
                  id="hide"
                  value="No"
                  v-model="inventory.isCorrosive"
                />
                <label for="hide" style="color: #A5A5A5; font-size: 14px">
                  &nbsp;&nbsp;&nbsp; No</label
                >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg text-left">
              <p style="color: #A5A5A5; font-size: 14px">Hazardous substance?</p>
              <div>
                <input
                  type="radio"
                  id="show"
                  value="Yes"
                  v-model="inventory.isHazardousSubstance"
                />
                <label for="show" style="color: #A5A5A5; font-size: 14px">
                  &nbsp;&nbsp;&nbsp; Yes</label
                >

                &nbsp;<input
                  type="radio"
                  id="hide"
                  value="No"
                  v-model="inventory.isHazardousSubstance"
                />
                <label for="hide" style="color: #A5A5A5; font-size: 14px">
                  &nbsp;&nbsp;&nbsp; No</label
                >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg text-left">
              <p style="color: #A5A5A5; font-size: 14px">Photo</p>
              <div class="row">
                <div class="col-lg-3 text-left">
                  <label for="image-upload">
                    <i
                      class="tim-icons icon-camera-18"
                      style="
                        top: 25%;
                        left: 30%;
                        position: absolute;
                        color: #707070;
                        font-size: 50px;
                      "
                    ></i>

                    <input
                      accept="image/*"
                      id="image-upload"
                      type="file"
                      ref="imageupload"
                      name="..."
                      class="valid"
                      :multiple="true"
                      aria-invalid="false"
                      style="
                        background-color: #ffffff;
                        border: 1px solid #707070;
                        height: 100px;
                        width: 130px;
                        color: #707070;
                      "
                      v-on:change="onImagesChange"
                    />
                  </label>
                </div>
                <div class="col-lg-3" v-if="previewImage != null">
                  <img
                    :src="previewImage"
                    style="height: 100px; width: 130px"
                  />
                </div>
                <div
                  class="col-lg-3"
                  v-for="(item, index) in inventory.images"
                  :key="index"
                >
                  <img :src="item" style="height: 100px; width: 130px" />
                </div>
              </div>
            </div>
          </div>

          <br />
          <div class="row">
            <div class="col-lg text-right">
              <base-button class="btn-primary" @click="submitInventory()"
                >Save</base-button
              >
            </div>
          </div>
        </b-card>
      </modal>
      <modal :show.sync="modals.image" class="modal-eprf-small" centered>
        <div class="row">
          <div class="col-lg text-left">
            <card>
              <img
                :src="image"
                width="700"
                style="min-width: 700px; max-width: 700px"
              />
            </card>
          </div>
          <div
            class=""
            style="
              position: absolute;
              top: 0;
              right: 0;
              padding-right: 50px;
              padding-top: 30px;
            "
          >
            <base-button class="btn-icon btn-cancel btn-round btn-sm">
              <i
                style="color: white; font-weight: 900; font-size: 12px"
                class="tim-icons icon-simple-remove"
                @click="modals.image = false"
              ></i>
            </base-button>
          </div>
        </div>
      </modal>
      <modal :show.sync="modals.addwastetype" class="modal-eprf-small" centered>
        <b-card
          class="card text-center"
          style="background-color: #f5f6fa; box-shadow: none"
          border-variant="primary"
          header="REASON FOR DISPUTE"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <template #header>
            <div class="row" style="margin-bottom: 10px">
              <div class="col-lg text-center">
                <h4 class="mb-0">
                  <span v-if="flag == 'add'">CREATE</span
                  ><span v-if="flag == 'edit'">EDIT</span> WASTE TYPE
                </h4>
              </div>
              <div
                class=""
                style="
                  position: absolute;
                  top: 0;
                  right: 0;
                  padding-right: 10px;
                  padding-top: 5px;
                "
              >
                <base-button class="btn-icon btn-cancel btn-round btn-sm">
                  <i
                    style="color: white; font-weight: 900; font-size: 12px"
                    class="tim-icons icon-simple-remove"
                    @click="modals.addwastetype = false"
                  ></i>
                </base-button>
              </div>
            </div>
          </template>
          <div class="row">
            <div class="col-lg text-left">
              <p style="color: #A5A5A5; font-size: 14px">Waste Type Name</p>
              <input
                type="text"
                v-model="wastetypess.name"
                :class="{ 'custom-input': true }"
              />
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-lg text-left">
              <p style="color: #A5A5A5; font-size: 14px">Description</p>
              <input
                type="text"
                v-model="wastetypess.description"
                :class="{ 'custom-input': true }"
              />
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-lg text-left">
              <p style="color: #A5A5A5; font-size: 14px">Show / hide</p>
              <div>
                <input
                  type="radio"
                  id="show"
                  value="Show"
                  v-model="wastetypess.isShow"
                />
                <label for="show" style="color: #A5A5A5; font-size: 14px">
                  &nbsp;&nbsp;&nbsp; Show</label
                >
                &nbsp;<input
                  type="radio"
                  id="hide"
                  value="Hide"
                  v-model="wastetypess.isShow"
                />
                <label for="hide" style="color: #A5A5A5; font-size: 14px">
                  &nbsp;&nbsp;&nbsp; Hide</label
                >
              </div>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-lg text-left">
              <p style="color: #A5A5A5; font-size: 14px">Waste Origin</p>
              <div>
                <input
                  type="radio"
                  id="show"
                  value="Land"
                  v-model="wastetypess.wasteorigin"
                />
                <label for="show" style="color: #A5A5A5; font-size: 14px">
                  &nbsp;&nbsp;&nbsp; Land</label
                >
                &nbsp;<input
                  type="radio"
                  id="hide"
                  value="Vessel"
                  v-model="wastetypess.wasteorigin"
                />
                <label for="hide" style="color: #A5A5A5; font-size: 14px">
                  &nbsp;&nbsp;&nbsp; Vessel</label
                >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg text-right">
              <base-button class="btn-primary" @click="submitWasteType()"
                >Save</base-button
              >
            </div>
          </div>
        </b-card>
      </modal>
      <modal :show.sync="modals.addportmgmt" class="modal-eprf-small" centered>
        <b-card
          class="card text-center"
          style="background-color: #f5f6fa; box-shadow: none"
          border-variant="primary"
          header="REASON FOR DISPUTE"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <template #header>
            <div class="row" style="margin-bottom: 10px">
              <div class="col-lg text-center">
                <h4 class="mb-0">
                  <span v-if="flag == 'add'">CREATE</span
                  ><span v-if="flag == 'edit'">EDIT</span> PORT
                </h4>
              </div>
              <div
                class=""
                style="
                  position: absolute;
                  top: 0;
                  right: 0;
                  padding-right: 10px;
                  padding-top: 5px;
                "
              >
                <base-button class="btn-icon btn-cancel btn-round btn-sm">
                  <i
                    style="color: white; font-weight: 900; font-size: 12px"
                    class="tim-icons icon-simple-remove"
                    @click="modals.addportmgmt = false"
                  ></i>
                </base-button>
              </div>
            </div>
          </template>

          <div class="row">
            <div class="col-lg text-left">
              <p style="color: #A5A5A5; font-size: 14px">Reference Number</p>
              <input
                type="text"
                v-model="port.refno"
                :class="{ 'custom-input': true }"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-lg text-left">
              <p style="color: #A5A5A5; font-size: 14px">Port Name</p>
              <input
                type="text"
                v-model="port.name"
                :class="{ 'custom-input': true }"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-lg text-left">
              <p style="color: #A5A5A5; font-size: 14px">Is Active</p>
              <toggle-button
                v-model="port.isactive"
                color="#358CCB"
                :sync="true"
                :width="100"
                :height="30"
                :labels="{ checked: 'Active', unchecked: 'Not Active' }"
              />
            </div>
          </div>
          <!-- hmm -->
          <div class="row" v-if="flag == 'edit'">
            <div class="col-lg text-left">
              <p style="color: #A5A5A5; font-size: 14px">Service Location Image</p>
              <div class="row">
                <div class="col-lg-3">
                  <label for="serimage">
                    <img src="@/assets/img/upload.png" width="73" height="45" />
                  </label>
                  <input
                    accept="image/*"
                    type="file"
                    name="..."
                    id="serimage"
                    ref="servicelocationimage"
                    @change="onserchange($event)"
                    :multiple="false"
                    style="display: none"
                  />
                </div>
                <div class="col-lg-3" style="padding-bottom: 5px" v-if="imageport != null">
                  <img :src="imageport.fileurl" width="73" height="45" />
                  <div style="position: absolute; right: 50%; top: 0">
                    <base-button
                     
                      class="btn-icon btn-cancel btn-round btn-xs"
                      @click="deleteimage(port.id)"
                      ><i class="fa fa-times" aria-hidden="true"></i
                    ></base-button>
                    <br />

                    <a :href="imageport.fileurl">
                      <base-button class="btn-icon btn-primary btn-round btn-xs"
                        ><i class="fa fa-arrow-down" aria-hidden="true"></i
                      ></base-button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <div class="row" style="height: 300px; overflow: auto;" >
            <div class="col-lg">
              <el-table
                :data="port.servicelocations"
                :header-cell-style="{
                  border: 'transparent',
                  'font-size': '14px',
                  'font-weight': '600',
                  'background-color': '#358DCC',

                  color: '#FFFFFF',
                }"
                style="
                  border-top-right-radius: 5px;
                  border-top-left-radius: 5px;
                "
                :cell-style="{
                  fontColor: '#707070',
                  border: 'transparent',
                  'font-size': '14px',
                }"
              >
                <el-table-column label="No" minWidth="30" align="center">
                  <div slot-scope="scope">
                    {{ scope.$index + 1 }}
                  </div>
                </el-table-column>

                <el-table-column
                  label="Service Location"
                  prop="servicelocation"
                >
                  <div slot-scope="{ row }">
                    <input
                      type="text"
                      v-model="row.servicelocation"
                      :class="{ 'custom-input': true }"
                    />
                  </div>
                </el-table-column>
                <el-table-column label="Type">
                  <div slot-scope="{ row }">
                    <el-select
                      class="select-info"
                      placeholder="Select Type"
                      v-model="row.type"
                      style="width: 95%; border-bottom: 1px solid lightgray"
                      filterable
                    >
                      <el-option
                        v-for="option in types"
                        class="select-info"
                        :value="option.value"
                        :label="option.label"
                        :key="option.value"
                      ></el-option>
                    </el-select>
                  </div>
                </el-table-column>
                <el-table-column label="Delete" width="80">
                  <div slot-scope="{ row }">
                    <base-button
                      v-if="row.isdeletable"
                      class="btn-icon btn-link"
                      @click="deletelocationcollection(row.id, row.locationid)"
                    >
                      <img src="@/assets/img/trash.png" width="50"
                    /></base-button>
                    <base-button
                      v-if="!row.isdeletable"
                      class="btn-icon btn-link"
                      disabled
                    >
                      <img src="@/assets/img/trash.png" width="50"
                    /></base-button>
                  </div>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="row">
            <div class="col-lg text-left">
              <base-button class="btn-link btn-primary" @click="addrow('port')"
                >+ Add row</base-button
              >
            </div>
          </div>

          <br />
          <div class="row">
            <div class="col-lg text-right">
              <base-button class="btn-primary" @click="submitPortMgmt()"
                >Save</base-button
              >
            </div>
          </div>
        </b-card>
      </modal>
      <modal :show.sync="modals.viewportmgmt" class="modal-eprf-small" centered>
        <b-card
          class="card text-center"
          style="background-color: #f5f6fa; box-shadow: none"
          border-variant="primary"
          header="REASON FOR DISPUTE"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <template #header>
            <div class="row" style="margin-bottom: 10px">
              <div class="col-lg text-center">
                <h4 class="mb-0">VIEW PORT</h4>
              </div>
              <div
                class=""
                style="
                  position: absolute;
                  top: 0;
                  right: 0;
                  padding-right: 10px;
                  padding-top: 5px;
                "
              >
                <base-button class="btn-icon btn-cancel btn-round btn-sm">
                  <i
                    style="color: white; font-weight: 900; font-size: 12px"
                    class="tim-icons icon-simple-remove"
                    @click="modals.viewportmgmt = false"
                  ></i>
                </base-button>
              </div>
            </div>
          </template>
          <div class="row">
            <div class="col-lg text-left">
              <p style="color: #A5A5A5; font-size: 14px">Port Name</p>
              <input
                type="text"
                v-model="port.name"
                :class="{ 'custom-input': true }"
              />
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-lg">
              <el-table
                :data="port.servicelocations"
                :header-cell-style="{
                  border: 'transparent',
                  'font-size': '14px',
                  'font-weight': '600',
                  'background-color': '#358DCC',

                  color: '#FFFFFF',
                }"
                style="
                  border-top-right-radius: 5px;
                  border-top-left-radius: 5px;
                "
                :cell-style="{
                  fontColor: '#707070',
                  border: 'transparent',
                  'font-size': '14px',
                }"
              >
                <el-table-column label="No" minWidth="30" align="center">
                  <div slot-scope="scope">
                    {{ scope.$index + 1 }}
                  </div>
                </el-table-column>
                <el-table-column
                  label="Service Location"
                  prop="servicelocation"
                >
                  <div slot-scope="{ row }">
                    <input
                      type="text"
                      v-model="row.servicelocation"
                      :class="{ 'custom-input': true }"
                    />
                  </div>
                </el-table-column>
                <el-table-column label="Type">
                  <div slot-scope="{ row }">
                    <el-select
                      class="select-info"
                      placeholder="Select Type"
                      v-model="row.type"
                      style="width: 95%; border-bottom: 1px solid lightgray"
                      filterable
                    >
                      <el-option
                        v-for="option in types"
                        class="select-info"
                        :value="option.value"
                        :label="option.label"
                        :key="option.value"
                      ></el-option>
                    </el-select>
                  </div>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="row">
            <div class="col-lg text-left">
              <base-button class="btn-link btn-primary" @click="addrow('port')"
                >+ Add row</base-button
              >
            </div>
          </div>

          <br />
          <div class="row">
            <div class="col-lg text-right">
              <base-button class="btn-primary">Save</base-button>
            </div>
          </div>
        </b-card>
      </modal>

      <br />

      <div class="row" style="margin-left: 5px">
        <div
          class="col-lg-3"
          style="background-color: #efefef; padding-top: 10%"
        >
          <div class="row">
            <div class="col-lg">
              <base-button
                @click="menunoti('pricerate')"
                v-if="switches.pricerate == false"
                class="btn-link"
                style="color: #A5A5A5; font-weight: 300"
                >Price Rate Settings</base-button
              >
              <base-button
                v-if="switches.pricerate == true"
                class="btn-link"
                style="color: #000000; font-weight: 600"
                ><i
                  class="fa fa-caret-right"
                  aria-hidden="true"
                  style="font-size: 20px; color: #368dcc"
                ></i
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Price Rate Settings
              </base-button>
            </div>
          </div>

          <div class="row">
            <div class="col-lg">
              <base-button
                @click="menunoti('concessionprice')"
                v-if="switches.concessionprice == false"
                class="btn-link"
                style="color: #A5A5A5; font-weight: 300"
                >Concession Price Rate</base-button
              >
              <base-button
                v-if="switches.concessionprice == true"
                class="btn-link"
                style="color: #000000; font-weight: 600"
                ><i
                  class="fa fa-caret-right"
                  aria-hidden="true"
                  style="font-size: 20px; color: #368dcc"
                ></i
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Concession Price
                Rate</base-button
              >
            </div>
          </div>

          <div class="row">
            <div class="col-lg">
              <base-button
                @click="menunoti('wastetypeproperties')"
                v-if="switches.wastetypeproperties == false"
                class="btn-link"
                style="color: #A5A5A5; font-weight: 300"
                >Waste Type Properties</base-button
              >
              <base-button
                v-if="switches.wastetypeproperties == true"
                class="btn-link"
                style="color: #000000; font-weight: 600"
                ><i
                  class="fa fa-caret-right"
                  aria-hidden="true"
                  style="font-size: 20px; color: #368dcc"
                ></i>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Waste Type Properties</base-button
              >
            </div>
          </div>

          <div class="row">
            <div class="col-lg">
              <base-button
                @click="menunoti('inventorymgmt')"
                v-if="switches.inventorymgmt == false"
                class="btn-link"
                style="color: #A5A5A5; font-weight: 300"
                >Inventory Management</base-button
              >
              <base-button
                v-if="switches.inventorymgmt == true"
                class="btn-link"
                style="color: #000000; font-weight: 600"
                ><i
                  class="fa fa-caret-right"
                  aria-hidden="true"
                  style="font-size: 20px; color: #368dcc"
                ></i>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Inventory Management</base-button
              >
            </div>
          </div>

          <div class="row">
            <div class="col-lg">
              <base-button
                @click="menunoti('portmgmt')"
                v-if="switches.portmgmt == false"
                class="btn-link"
                style="color: #A5A5A5; font-weight: 300"
                >Port Management</base-button
              >
              <base-button
                v-if="switches.portmgmt == true"
                class="btn-link"
                style="color: #000000; font-weight: 600"
                ><i
                  class="fa fa-caret-right"
                  aria-hidden="true"
                  style="font-size: 20px; color: #368dcc"
                ></i>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Port Management</base-button
              >
            </div>
          </div>
        </div>
        <div
          class="col-lg-9"
          style="
            background-color: #ffffff;
            height: 750px;

            padding-bottom: 10%;
          "
        >
          <!-- price rate -->
          <div
            class="row"
            style="padding-top: 3%; margin: 10px"
            v-if="switches.pricerate == true"
          >
            <div class="col-lg">
              <div class="row">
                <div class="col-lg">
                  <div class="row">
                    <div class="col-lg">
                      <p class="custom-title">Price Rate Settings</p>
                    </div>
                  </div>

                  <br />
                  <div class="row">
                    <div class="col-lg">
                      <base-button @click="addPriceRate()">+ Add</base-button>
                    </div>
                    <div class="col-lg-3 text-right">
                      <el-input
                        type="search"
                        class="mb-3 search-input"
                        prefix-icon="el-icon-search"
                        placeholder="Search.."
                        v-model="searchPriceRate"
                        aria-controls="datatables"
                      ></el-input>
                    </div>
                  </div>

                  <br />
                  <div
                    class="row"
                    style="height: 500px; overflow: scroll; overflow-x: hidden"
                  >
                    <div class="col-lg">
                      <el-table
                        :data="pricerates"
                        :header-cell-style="{
                          border: 'transparent',
                          'font-size': '14px',
                          'font-weight': '600',
                          color: '#000000',
                        }"
                        :cell-style="{
                          fontColor: '#707070',
                          border: 'transparent',
                          'font-size': '14px',
                        }"
                      >
                        <el-table-column
                          label="Item"
                          prop="item"
                          minWidth="60"
                        ></el-table-column>
                        <el-table-column
                          minWidth="180"
                          label="Description"
                          prop="description"
                        ></el-table-column>
                        <el-table-column
                          label="Price/kg(RM)"
                          prop="price"
                          align="center"
                        ></el-table-column>
                        <el-table-column
                          label="Date Created"
                          prop="datecreated"
                        ></el-table-column>
                        <el-table-column
                          label="Last Edited"
                          prop="lastedited"
                        ></el-table-column>
                        <el-table-column label="Edit">
                          <div slot-scope="{ row }">
                            <i
                              class="fa fa-pencil-square-o"
                              aria-hidden="true"
                              style="color: pink"
                            ></i>
                            <base-button
                              class="btn-icon btn-link"
                              @click="getData(row)"
                            >
                              <img
                                src="@/assets/img/eprf-edit.png"
                                width="30"
                              />
                            </base-button>
                          </div>
                        </el-table-column>
                        <el-table-column label="Delete">
                          <div slot-scope="{ row }">
                            <base-button
                              class="btn-icon btn-link"
                              @click="deletePriceRate(row.id)"
                            >
                              <img src="@/assets/img/trash.png" width="30" />
                            </base-button>
                          </div>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- concession price -->
          <div
            class="row"
            style="padding-top: 3%; margin: 10px"
            v-if="switches.concessionprice == true"
          >
            <div class="col-lg">
              <div class="row">
                <div class="col-lg">
                  <div class="row">
                    <div class="col-lg">
                      <p class="custom-title">Concession Price Rate</p>
                    </div>
                  </div>

                  <br />
                  <div class="row">
                    <div class="col-lg">
                      <base-button @click="addConcession()">+ Add</base-button>
                    </div>
                    <div class="col-lg-3 text-right">
                      <el-input
                        type="search"
                        class="mb-3 search-input"
                        prefix-icon="el-icon-search"
                        placeholder="Search.."
                        v-model="searchQueryConcession"
                        aria-controls="datatables"
                      ></el-input>
                    </div>
                  </div>

                  <br />
                  <div
                    class="row"
                    style="height: 500px; overflow: scroll; overflow-x: hidden"
                  >
                    <div class="col-lg">
                      <el-table
                        :data="concessionprices"
                        :header-cell-style="{
                          border: 'transparent',
                          'font-size': '14px',
                          'font-weight': '600',
                          color: '#000000',
                        }"
                        :cell-style="{
                          fontColor: '#707070',
                          border: 'transparent',
                          'font-size': '14px',
                        }"
                      >
                        <el-table-column
                          label="Customer"
                          prop="customer"
                          minWidth="60"
                        ></el-table-column>
                        <el-table-column
                          minWidth="180"
                          label="Item(s) with Concession "
                          prop="item"
                        >
                          <div slot-scope="{ row }">
                            <p
                              v-for="(item, index) in row.item"
                              :key="index"
                              style="
                                text-overflow: ellipsis;
                                width: 150px;
                                overflow: hidden;
                                white-space: nowrap;
                              "
                            >
                              {{ item.name }}
                            </p>
                          </div>
                        </el-table-column>
                        <el-table-column
                          label="Expiry Date"
                          prop="expirydate"
                        ></el-table-column>
                        <el-table-column
                          label="Date Created"
                          prop="datecreated"
                        ></el-table-column>
                        <el-table-column
                          label="Last Edited"
                          prop="lastedited"
                        ></el-table-column>
                        <el-table-column label="Edit">
                          <div slot-scope="{ row }">
                            <i
                              class="fa fa-pencil-square-o"
                              aria-hidden="true"
                              style="color: pink"
                            ></i>
                            <base-button
                              class="btn-icon btn-link"
                              @click="getData(row)"
                            >
                              <img
                                src="@/assets/img/eprf-edit.png"
                                width="30"
                              />
                            </base-button>
                          </div>
                        </el-table-column>
                        <el-table-column label="Delete">
                          <div slot-scope="{ row }">
                            <base-button
                              class="btn-icon btn-link"
                              @click="deleteConcession(row.id)"
                            >
                              <img src="@/assets/img/trash.png" width="30" />
                            </base-button>
                          </div>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- inventory management -->
          <div
            class="row"
            style="padding-top: 3%; margin: 10px"
            v-if="switches.inventorymgmt == true"
          >
            <div class="col-lg">
              <div class="row">
                <div class="col-lg">
                  <div class="row">
                    <div class="col-lg">
                      <p class="custom-title">Inventory Management</p>
                    </div>
                  </div>

                  <br />
                  <div class="row">
                    <div class="col-lg">
                      <base-button @click="addInventory()">+ Add</base-button>
                    </div>
                    <div class="col-lg-3 text-right">
                      <el-input
                        type="search"
                        class="mb-3 search-input"
                        prefix-icon="el-icon-search"
                        placeholder="Search.."
                        v-model="searchQueryInventory"
                        aria-controls="datatables"
                      ></el-input>
                    </div>
                  </div>

                  <br />
                  <div
                    class="row"
                    style="height: 500px; overflow: scroll; overflow-x: hidden"
                  >
                    <div class="col-lg">
                      <el-table
                        :data="inventorymgmts"
                        :header-cell-style="{
                          border: 'transparent',
                          'font-size': '14px',
                          'font-weight': '600',
                          color: '#000000',
                        }"
                        :cell-style="{
                          fontColor: '#707070',
                          border: 'transparent',
                          'font-size': '14px',
                        }"
                      >
                        <el-table-column
                          label="Item"
                          prop="item"
                          minWidth="90"
                        ></el-table-column>
                        <el-table-column
                          minWidth="180"
                          label="Description"
                          prop="description"
                        ></el-table-column>
                        <el-table-column
                          minWidth="150"
                          label="Service Location"
                          prop="servicelocation"
                        ></el-table-column>
                        <el-table-column
                          minWidth="100"
                          label="Last Edited"
                          prop="lastedited"
                        ></el-table-column>
                        <el-table-column label="Image" align="center">
                          <div slot-scope="{ row }">
                            <base-button
                              class="btn-primary btn-link"
                              @click="viewImage(row)"
                              >View</base-button
                            >
                          </div>
                        </el-table-column>
                        <el-table-column
                          label="Download QR"
                          align="center"
                          minWidth="90"
                        >
                          <div slot-scope="{ row }">
                            <base-button
                              class="btn-primary btn-link"
                              @click="downloadQR(row)"
                              ><i class="fa fa-download" aria-hidden="true"></i
                            ></base-button></div
                        ></el-table-column>
                        <el-table-column label="Edit">
                          <div slot-scope="{ row }">
                            <i
                              class="fa fa-pencil-square-o"
                              aria-hidden="true"
                              style="color: pink"
                            ></i>
                            <base-button
                              class="btn-icon btn-link"
                              @click="getData(row)"
                            >
                              <img
                                src="@/assets/img/eprf-edit.png"
                                width="30"
                              />
                            </base-button>
                          </div>
                        </el-table-column>
                        <el-table-column label="Delete">
                          <div slot-scope="{ row }">
                            <base-button
                              class="btn-icon btn-link"
                              @click="deleteInventory(row.id)"
                            >
                              <img src="@/assets/img/trash.png" width="30" />
                            </base-button>
                          </div>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- waste type property -->
          <div
            class="row"
            style="padding-top: 5%; padding-left: 2%"
            v-if="switches.wastetypeproperties == true"
          >
            <div class="col-lg">
              <div class="row">
                <div class="col-lg">
                  <div class="row">
                    <div class="col-lg">
                      <p class="custom-title">Waste Type Properties Settings</p>
                    </div>
                  </div>

                  <br />
                  <div class="row">
                    <div class="col-lg">
                      <base-button @click="addWasteType()">+ Add</base-button>
                    </div>
                    <div class="col-lg-3 text-right">
                      <el-input
                        type="search"
                        class="mb-3 search-input"
                        prefix-icon="el-icon-search"
                        placeholder="Search.."
                        v-model="searchQueryWasteType"
                        aria-controls="datatables"
                      ></el-input>
                    </div>
                  </div>

                  <br />
                  <div
                    class="row"
                    style="height: 500px; overflow: scroll; overflow-x: hidden"
                  >
                    <div class="col-lg">
                      <el-table
                        :data="wastetypess.wastetypes"
                        :header-cell-style="{
                          border: 'transparent',
                          'font-size': '14px',
                          'font-weight': '600',
                          color: '#000000',
                        }"
                        :cell-style="{
                          fontColor: '#707070',
                          border: 'transparent',
                          'font-size': '14px',
                        }"
                      >
                        <el-table-column
                          label="Waste Type"
                          prop="wastetype"
                          minWidth="180"
                        ></el-table-column>
                        <el-table-column
                          minWidth="180"
                          label="Description"
                          prop="description"
                        ></el-table-column>
                        <el-table-column
                          minWidth="140"
                          label="Land / Vessel Origin"
                          prop="origin"
                        ></el-table-column>
                        <el-table-column
                          minWidth="90"
                          label="Date Created"
                          prop="datecreated"
                        ></el-table-column>
                        <el-table-column
                          minWidth="90"
                          label="Last Edited"
                          prop="lastedited"
                        ></el-table-column>
                        <el-table-column label="Edit">
                          <div slot-scope="{ row }">
                            <i
                              class="fa fa-pencil-square-o"
                              aria-hidden="true"
                              style="color: pink"
                            ></i>
                            <base-button
                              class="btn-icon btn-link"
                              @click="getData(row)"
                            >
                              <img
                                src="@/assets/img/eprf-edit.png"
                                width="30"
                              />
                            </base-button>
                          </div>
                        </el-table-column>
                        <el-table-column label="Delete">
                          <div slot-scope="{ row }">
                            <base-button
                              class="btn-icon btn-link"
                              @click="deleteWasteType(row.id)"
                            >
                              <img src="@/assets/img/trash.png" width="30" />
                            </base-button>
                          </div>
                          <div></div>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- port management -->
          <div
            class="row"
            style="padding-top: 5%; padding-left: 2%"
            v-if="switches.portmgmt == true"
          >
            <div class="col-lg">
              <div class="row">
                <div class="col-lg">
                  <div class="row">
                    <div class="col-lg">
                      <p class="custom-title">Port Management Settings</p>
                    </div>
                  </div>

                  <br />
                  <div class="row">
                    <div class="col-lg">
                      <base-button @click="addPortMgmt()">+ Add</base-button>
                    </div>
                    <div class="col-lg-3 text-right">
                      <el-input
                        type="search"
                        class="mb-3 search-input"
                        prefix-icon="el-icon-search"
                        placeholder="Search.."
                        v-model="searchQueryPortMgmt"
                        aria-controls="datatables"
                      ></el-input>
                    </div>
                  </div>

                  <br />
                  <div
                    class="row"
                    style="height: 500px; overflow: scroll; overflow-x: hidden"
                  >
                    <div class="col-lg">
                      <el-table
                        :data="ports"
                        :header-cell-style="{
                          border: 'transparent',
                          'font-size': '14px',
                          'font-weight': '600',
                          color: '#000000',
                        }"
                        :cell-style="{
                          fontColor: '#707070',
                          border: 'transparent',
                          'font-size': '14px',
                        }"
                      >
                        <el-table-column
                          label="Port"
                          prop="port"
                          minWidth="80"
                        ></el-table-column>

                        <el-table-column
                          label="Last Edited"
                          prop="lastedited"
                        ></el-table-column>
                        <el-table-column label="Edit">
                          <div slot-scope="{ row }">
                            <i
                              class="fa fa-pencil-square-o"
                              aria-hidden="true"
                              style="color: pink"
                            ></i>
                            <base-button
                              class="btn-icon btn-link"
                              @click="getData(row)"
                            >
                              <img
                                src="@/assets/img/eprf-edit.png"
                                width="30"
                              />
                            </base-button>
                          </div>
                        </el-table-column>
                        <el-table-column label="Delete">
                          <div slot-scope="{ row }">
                            <base-button
                              class="btn-icon btn-link"
                              @click="deletePort(row.id)"
                            >
                              <img src="@/assets/img/trash.png" width="30" />
                            </base-button>
                          </div>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ToggleButton } from "vue-js-toggle-button";
import {
  Tooltip,
  DatePicker,
  TimePicker,
  TimeSelect,
  Table,
  TableColumn,
  Select,
  Option,
} from "element-ui";
import swal from "sweetalert2";
import { Modal } from "src/components";
import { BCard } from "bootstrap-vue";
import moment from "moment";
import { debounce } from "src/util/debounce";
import jsPDF from "jspdf";
import QRCode from "qrcode";
import StatusModal from "src/components/StatusModal.vue";
import { modal } from "src/components/variable.js";

export default {
  components: {
    ToggleButton,
    StatusModal,
    [Tooltip.name]: Tooltip,
    [DatePicker.name]: DatePicker,
    [TimePicker.name]: TimePicker,
    [TimeSelect.name]: TimeSelect,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    Modal,
    BCard,
  },
  data() {
    return {
      imageport: null,
      modal: modal,
      previewImage: null,
      flag: "",
      searchQueryInventory: "",
      searchQueryWasteType: "",
      searchQueryPortMgmt: "",
      searchQueryConcession: "",

      searchPriceRate: "",
      image: "",
      item: "",
      timeselectclass: "background-color: pink; border-radius: 50px;",
      switches: {
        pricerate: true,
        concessionprice: false,
        inventorymgmt: false,
        wastetypeproperties: false,
        portmgmt: false,
      },
      pricerates: [
        {
          id: 1,
          item: "SW 1",
          description: "Metal and non metal waste",
          price: "20",
          datecreated: "11 / 12 / 2023",
          lastedited: "11 / 12 / 2023",
        },
      ],
      priceratestemp: [],
      modals: {
        addnewpriceentry: false,
        addconcessionprice: false,
        addInventoryMgmt: false,
        image: false,
        addwastetype: false,
        addportmgmt: false,
        successModal: false,
        failedModal: false,
        viewportmgmt: false,
      },
      message: "",
      pricerate: {
        id: "",
        item: "",
        description: "",
        price: "",
        items: [],
      },
      concessionpricestemp: [],
      concessionprices: [
        {
          id: 1,
          customer: "Wan Hai",
          item: "SW 1",
          price: "20",
          datecreated: "11 / 12 / 2023",
          lastedited: "11 / 12 / 2023",
        },
      ],
      wastesubtypes: [],
      wastetypes: [
        {
          label: "Waste type A",
          value: "Waste type A",
        },
        {
          label: "Waste type B",
          value: "Waste type B",
        },
        {
          label: "Waste type C",
          value: "Waste type C",
        },
      ],
      concessionprice: {
        concessionid: "",
        id: "",
        customer: "",
        customers: [],
        wastetypes: [
          {
            id: "",
            wastetype: "Waste type C",
            price: "300",
          },
        ],
        expirydate: "",
      },
      inventorymgmts: [
        {
          item: "SW 1",
          description: "Metal and metal-bearing waste",
          servicelocation: "North Port",
          lastedited: "11 / 12 / 2024",
          imageurl: require("@/assets/img/VECTOLABS.png"),
          qrimageurl: require("@/assets/img/qr.png"),
        },
      ],
      inventorytemp: [],
      inventory: {
        id: "",
        wastetype: "",
        item: "",
        description: "",
        servicelocation: "",

        isShow: "Show",
        isShowPreprocessing: "Show",
        isShowPostprocessing: "Show",
        isSellableProduct: "Yes",
        isHazardousSubstance: "Yes",
        isCorrosive: "Yes",
        photo: null,
        images: [
          // "https://picsum.photos/200/300",
          // "https://picsum.photos/200/300",
        ],
      },
      servicelocations: [
        {
          label: "Service Location A",
          value: "Service Location A",
        },
        {
          label: "Service Location B",
          value: "Service Location B",
        },
      ],
      wastetypess: {
        id: "",
        name: "",
        description: "",
        isShow: "Show",
        wasteorigin: "Vessel",
        wastetypes: [
          {
            wastetype: "Scheduled Waste",
            description: "Waste code used by AFES PRF",
            origin: "LAND",
            datecreated: "11/12/2024",
            lastedited: "11/12/2024",
          },
          {
            wastetype: "Scheduled Waste",
            description: "Waste code used by AFES PRF",
            origin: "LAND",
            datecreated: "11/12/2024",
            lastedited: "11/12/2024",
          },
          {
            wastetype: "Scheduled Waste",
            description: "Waste code used by AFES PRF",
            origin: "LAND",
            datecreated: "11/12/2024",
            lastedited: "11/12/2024",
          },
          {
            wastetype: "Scheduled Waste",
            description: "Waste code used by AFES PRF",
            origin: "LAND",
            datecreated: "11/12/2024",
            lastedited: "11/12/2024",
          },
        ],
        wastetypestemp: [],
      },
      port: {
        id: "",
        name: "",
        isactive: false,
        refno: "",
        servicelocations: [
          {
            servicelocation: "",
            type: "",
            id: 0,
            isactive: false,
            reference_number: "",
          },
        ],
      },
      ports: [
        {
          port: "Northport",
          address:
            "Jalan Pelabuhan, Pelabuhan Utara, 42000 Port Klang, Malaysia.",
          servicelocation: [
            {
              servicelocation: "ServiceLocationA",
              type: "LAND",
            },
            {
              servicelocation: "ServiceLocationA",
              type: "LAND",
            },
            {
              servicelocation: "ServiceLocationA",
              type: "LAND",
            },
          ],
          datecreated: "11 / 12 / 2024",
          lastedited: "11 / 12 / 2024",
        },
      ],
      portstemp: [],
      types: [
        {
          label: "Land",
          value: "land",
        },
        {
          label: "Vessel",
          value: "vessel",
        },
      ],
      name: "hui",
    };
  },
  methods: {
    deleteimage(imageid){
      this.$http
        .delete(
          ":10001/api/v1/setting-private/service_location/"+ this.port.id+"/logo"
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            this.message = response;
            this.modals.removeModal = true;
            this.modals.addportmgmt = false
            this.getPortData();
          }
        });
    },
    onserchange(e) {
      const t = e.target;
      const formData = new FormData();
      console.log(t.files[0]);

      for (var i = 0; i < t.files.length; i++) {
        let o = t.files[i];

        formData.append("image", o);
      }

      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }
      this.$http
        .post(
          ":10001/api/v1/setting-private/service_location_logo?service_location_id=" +
            this.port.id,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = "Image successfully uploaded.";
            this.modals.successModal = true;
            this.modals.addportmgmt = false
            this.getPortData();
          }
        });
    },
    getCustomer() {
      this.concessionprice.customers = [];

      this.$http.get(":10001/api/v1/concession/company_list").then((res) => {
        if (!res.error) {
          let response = res.message;

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].company_name,
              value: response[i].company_id,
            };
            this.concessionprice.customers.push(obj);
          }
        }
      });
    },
    getConcessionPriceRate() {
      this.concessionprices = [];
      this.concessionpricestemp = [];

      this.$http.get(":10001/api/v1/concession").then((res) => {
        if (!res.error) {
          let response = res.message;

          for (var i = 0; i < response.length; i++) {
            let wastes = [];
            for (var j = 0; j < response[i].wastes.length; j++) {
              let ws = {
                name: response[i].wastes[j].name,
                id: response[i].wastes[j].waste_concession_id,
                price: response[i].wastes[j].price,
              };
              wastes.push(ws);
            }
            let obj = {
              id: response[i].concession_id,
              customer: response[i].company_name,
              item: wastes,
              expirydate: moment(response[i].expired_date).format("DD/MM/YYYY"),
              datecreated: moment(response[i].date_created).format(
                "DD/MM/YYYY"
              ),
              lastedited: moment(response[i].last_edited).format("DD/MM/YYYY"),
            };
            this.concessionprices.push(obj);
            this.concessionpricestemp.push(obj);
          }

          if (this.searchQueryConcession != "") {
            let tempsearch = this.searchQueryConcession;
            this.searchQueryConcession = "";

            setTimeout(() => {
              this.searchQueryConcession = tempsearch;
            }, response.length);
          }
        }
      });
    },
    submitPortMgmt() {
      if (this.port.name != "") {
        // marshall collection location
        let collectionlocation = [];
        for (var i = 0; i < this.port.servicelocations.length; i++) {
          let cl = {
            service_location_collection_id: this.port.servicelocations[i].id,
            name: this.port.servicelocations[i].servicelocation,
            type: this.port.servicelocations[i].type, //land | vessel
            is_active: true,
          };
          collectionlocation.push(cl);
        }
        let obj = {
          location: this.port.name,
          is_active: this.port.isactive,
          collection_location: collectionlocation,
          reference_number: this.port.refno,
        };

        if (this.flag == "add") {
          this.$http
            .post(":10001/api/v1/setting-private/service_location", obj)
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                this.message = response;
                this.modals.successModal = true;
                this.getPortData();
                this.modals.addportmgmt = false;
              }
            });
        }

        if (this.flag == "edit") {
          this.$http
            .put(
              ":10001/api/v1/setting-private/service_location/" + this.port.id,
              obj
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                this.message = response;
                this.modals.successModal = true;
                this.getPortData();
                this.modals.addportmgmt = false;
              }
            });
        }
      } else {
        swal({
          title: "Data Error!",
          text: "Item and price is compulsory. ",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false,
        });
      }
    },
    addConcession() {
      this.flag = "add";
      this.concessionprice.customer = "";
      this.concessionprice.wastetypes = [{}];
      this.concessionprice.price = "";

      this.modals.addconcessionprice = true;
    },
    addPortMgmt() {
      this.flag = "add";
      this.port.name = "";
      this.port.servicelocations = [];
      this.port.servicelocations.push({
        servicelocation: "",
        type: "",
        id: 0,
      });
      this.modals.addportmgmt = true;
    },
    addPriceRate() {
      this.flag = "add";
      this.pricerate.item = "";
      this.pricerate.description = "";
      this.pricerate.price = "";
      this.modals.addnewpriceentry = true;
    },
    submitConcession() {
      if (
        this.concessionprice.customer != "" &&
        this.concessionprice.wastetypes.length != 0 &&
        this.concessionprice.expirydate != ""
      ) {
        let wastes = [];
        for (var i = 0; i < this.concessionprice.wastetypes.length; i++) {
          let con = {
            waste_sub_type_id: this.concessionprice.wastetypes[i].wastetype,
            price: parseFloat(this.concessionprice.wastetypes[i].price),
          };
          wastes.push(con);
        }
        let obj = {
          company_id: this.concessionprice.customer,
          wastes: wastes,
          expired_date: moment(this.concessionprice.expirydate).format(
            "YYYY-MM-DD"
          ), //YYYY-MM-DD
        };

        if (this.flag == "add") {
          this.$http.post(":10001/api/v1/concession", obj).then((res) => {
            if (!res.error) {
              let response = res.message;

              this.getConcessionPriceRate();
              this.message = response;
              this.modals.successModal = true;
              this.modals.addconcessionprice = false;
            } else {
              let response = res.message;
              this.message = response;
              this.modals.addconcessionprice = false;
              this.modals.failedModal = true;
            }
          });
        }

        if (this.flag == "edit") {
          let wastes = [];
          for (var i = 0; i < this.concessionprice.wastetypes.length; i++) {
            let ws = {
              waste_concession_id: this.concessionprice.wastetypes[i].id,
              waste_sub_type_id: this.concessionprice.wastetypes[i].wastetype,
              price: parseFloat(this.concessionprice.wastetypes[i].price),
            };
            wastes.push(ws);
          }
          let obj = {
            company_id: this.concessionprice.id,
            wastes: wastes,
            expired_date: moment(this.concessionprice.expirydate).format(
              "YYYY-MM-DD"
            ), //YYYY-MM-DD
          };

          this.$http
            .put(
              ":10001/api/v1/concession/" + this.concessionprice.concessionid,
              obj
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                this.getConcessionPriceRate();
                this.message = response;
                this.modals.successModal = true;
                this.modals.addconcessionprice = false;
              } else {
                let response = res.message;
                this.message = response;
                this.modals.addconcessionprice = false;
                this.modals.failedModal = true;
              }
            });
        }
      } else {
        swal({
          title: "Data Error!",
          text: "All data are compulsory. ",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false,
        });
      }
    },
    submitPriceRate() {
      if (this.pricerate.item != "" && this.pricerate.price != "") {
        let obj = {
          price: parseFloat(this.pricerate.price),
        };

        this.$http
          .put(
            ":10001/api/v1/setting-private/waste_sub_type/" +
              this.pricerate.item +
              "/price",
            obj
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;

              this.getPriceRate();
              this.modals.addnewpriceentry = false;
              this.message = response;
              this.modals.successModal = true;

              this.pricerate.description = "";
              this.pricerate.price = "";
            }
          });
      } else {
        swal({
          title: "Data Error!",
          text: "Item and price is compulsory. ",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false,
        });
      }
    },
    getItems() {
      this.pricerate.items = [];

      this.$http
        .get(":10001/api/v1/setting-private/waste_sub_type/price-dropdown")
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            for (var i = 0; i < response.length; i++) {
              let obj = {
                label: response[i].item,
                value: response[i].waste_sub_type_id,
                description: response[i].description,
              };
              this.pricerate.items.push(obj);
            }
          }
        });
    },
    getPriceRate() {
      this.pricerates = [];
      this.priceratestemp = [];

      this.$http
        .get(":10001/api/v1/setting-private/waste_sub_type/price")
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            for (var i = 0; i < response.length; i++) {
              let obj = {
                id: response[i].waste_sub_type_id,
                item: response[i].item,
                description: response[i].description,
                price: response[i].price,
                datecreated: moment(response[i].date_created).format(
                  "DD/MM/YYYY"
                ),
                lastedited: moment(response[i].last_updated).format(
                  "DD/MM/YYYY"
                ),
              };
              this.pricerates.push(obj);
              this.priceratestemp.push(obj);
            }

            if (this.searchPriceRate != "") {
              let tempsearch = this.searchPriceRate;
              this.searchPriceRate = "";

              setTimeout(() => {
                this.searchPriceRate = tempsearch;
              }, response.length);
            }
          }
        });
    },
    viewServiceLocation(data) {
      this.modals.viewportmgmt = true;
      this.port.name = data.port;
      this.port.servicelocations = data.servicelocation;
    },
    getPortData() {
      this.ports = [];
      this.portstemp = [];

      this.$http
        .get(":10001/api/v1/setting-private/service_location")
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            for (var i = 0; i < response.length; i++) {
              let locationcollections = [];

              for (
                var j = 0;
                j < response[i].service_location_collection.length;
                j++
              ) {
                let aa = {
                  id: response[i].service_location_collection[j]
                    .service_location_collection_id,
                  locationid:
                    response[i].service_location_collection[j]
                      .service_location_id,
                  servicelocation:
                    response[i].service_location_collection[j].name,
                  refno:
                    response[i].service_location_collection[j].reference_number,
                  isdeletable:
                    response[i].service_location_collection[j].is_deletable,
                };
                locationcollections.push(aa);
              }
              let obj = {
                id: response[i].service_location_id,
                port: response[i].location,
                isactive: response[i].is_active,
                logo: response[i].logo,
                servicelocation: locationcollections,
                lastedited: moment(response[i].last_edited).format(
                  "DD/MMM/YYYY"
                ),
              };
              this.ports.push(obj);
              this.portstemp.push(obj);
            }
          }
        });
    },
    submitWasteType() {
      if (
        this.wastetypess.name != "" &&
        this.wastetypess.description != "" &&
        this.wastetypess.isShow != "" &&
        this.wastetypess.wasteorigin != ""
      ) {
        let obj = {
          name: this.wastetypess.name,
          description: this.wastetypess.description,
          show: this.wastetypess.isShow == "Show" ? true : false,
          origin: this.wastetypess.wasteorigin == "Land" ? "land" : "vessel",
        };

        if (this.flag == "add") {
          this.$http
            .post(":10001/api/v1/setting-private/waste_type", obj)
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                this.modals.addwastetype = false;
                this.message = response;
                this.modals.successModal = true;
                this.getWasteTypeData();
              }
            });
        }

        if (this.flag == "edit") {
          this.$http
            .put(
              ":10001/api/v1/setting-private/waste_type/" + this.wastetypess.id,
              obj
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                this.modals.addwastetype = false;
                this.message = response;
                this.modals.successModal = true;
                this.getWasteTypeData();
              }
            });
        }
      } else {
        swal({
          title: "Data Error!",
          text: "All data must be filled in.",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false,
        });
      }
    },
    addWasteType() {
      this.flag = "add";
      this.wastetypess.name = "";
      this.wastetypess.description = "";
      this.wastetypess.isShow = "";
      this.wastetypess.wasteorigin = "";
      this.modals.addwastetype = true;
    },
    getWasteTypeData() {
      this.wastetypess.wastetypes = [];
      this.wastetypess.wastetypestemp = [];

      this.$http.get(":10001/api/v1/setting-private/waste_type").then((res) => {
        if (!res.error) {
          let response = res.message;

          for (var i = 0; i < response.length; i++) {
            let obj = {
              id: response[i].waste_type_id,
              wastetype: response[i].name,
              description: response[i].description,
              origin: response[i].for_vessel == false ? "Land" : "Vessel",
              datecreated: moment(response[i].created_at).format("DD/MM/YYYY"),
              lastedited: moment(response[i].updated_at).format("DD/MM/YYYY"),
            };
            this.wastetypess.wastetypes.push(obj);
            this.wastetypess.wastetypestemp.push(obj);
          }

          if (this.searchQueryWasteType != "") {
            let tempsearch = this.searchQueryWasteType;
            this.searchQueryWasteType = "";

            setTimeout(() => {
              this.searchQueryWasteType = tempsearch;
            }, response.length);
          }
        }
      });
    },
    getServiceLocation() {
      this.servicelocations = [];

      this.$http
        .get(":10001/api/v1/setting-private/service_location")
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            for (var i = 0; i < response.length; i++) {
              let obj = {
                label: response[i].location,
                value: response[i].service_location_id,
              };
              this.servicelocations.push(obj);
            }
          }
        });
    },
    getWasteType() {
      this.wastetypes = [];

      this.$http.get(":10001/api/v1/setting-private/waste_type").then((res) => {
        if (!res.error) {
          let response = res.message;

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].name,
              value: response[i].waste_type_id,
            };
            this.wastetypes.push(obj);
          }
        }
      });
    },
    submitInventory() {
      if (
        this.inventory.wastetype != "" &&
        this.inventory.item != "" &&
        this.inventory.description != "" &&
        this.inventory.servicelocation != ""
      ) {
        const formData = new FormData();
        formData.append("service_location_id", this.inventory.servicelocation);
        formData.append("waste_type_id", this.inventory.wastetype);
        formData.append("name", this.inventory.item);
        formData.append("description", this.inventory.description);
        formData.append("show", this.inventory.isShow == "Show" ? true : false);
        formData.append(
          "preprocessing",
          this.inventory.isShowPreprocessing == "Show" ? true : false
        );
        formData.append(
          "postprocessing",
          this.inventory.isShowPostprocessing == "Show" ? true : false
        );
        formData.append(
          "sellable",
          this.inventory.isSellableProduct == "Yes" ? true : false
        );
        formData.append(
          "corrosive",
          this.inventory.isCorrosive == "Yes" ? true : false
        );
        formData.append(
          "hazardous",
          this.inventory.IsHazardousSubstance == "Yes" ? true : false
        );
        formData.append("documents", this.inventory.images);

        if (this.flag == "add") {
          this.$http
            .post(":10001/api/v1/setting-private/waste_sub_type", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + sessionStorage.getItem("token"),
              },
            })
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                this.previewImage = null;
                this.inventory.images = [];
                this.modals.addInventoryMgmt = false;
                this.message = response;
                this.modals.successModal = true;
                this.getInventory();
              }
            });
        }

        if (this.flag == "edit") {
          this.$http
            .put(
              ":10001/api/v1/setting-private/waste_sub_type/" +
                this.inventory.id,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: "Bearer " + sessionStorage.getItem("token"),
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                this.previewImage = null;
                this.inventory.images = [];
                this.modals.addInventoryMgmt = false;
                this.message = response;
                this.modals.successModal = true;
                this.getInventory();
              }
            });
        }
      } else {
        swal({
          title: "Data Error!",
          text: "All data must be filled in.",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false,
        });
      }
    },
    addInventory() {
      this.flag = "add";

      // clear state
      this.inventory.id = "";
      this.inventory.wastetype = "";
      this.inventory.item = "";
      this.inventory.description = "";
      this.inventory.servicelocation = "";
      this.inventory.isShow = "";
      this.inventory.isShowPreprocessing = "";
      this.inventory.isShowPostprocessing = "";
      this.inventory.isSellableProduct = "";
      this.inventory.isHazardousSubstance = "";
      this.inventory.isCorrosive = "";
      this.inventory.images = null;

      this.modals.addInventoryMgmt = true;
    },
    deletelocationcollection(collectionid, locationid) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/setting-private/service_location/" +
                locationid +
                "/" +
                collectionid
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                this.modals.addportmgmt = false;
                this.getPortData();

                this.message = response;
                this.modals.successModal = true;
              }
            });
        }
      });
    },
    deleteConcession(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value == true) {
          this.$http.delete(":10001/api/v1/concession/" + id).then((res) => {
            if (!res.error) {
              let response = res.message;

              this.getConcessionPriceRate();

              this.message = response;
              this.modals.successModal = true;
            }
          });
        }
      });
    },
    deletePort(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value == true) {
          this.$http
            .delete(":10001/api/v1/setting-private/service_location/" + id)
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                this.message = response;
                this.modals.successModal = true;
                this.getPortData();
              }
            });
        }
      });
    },
    deletePriceRate(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/setting-private/waste_sub_type/" + id + "/price"
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                this.message = response;
                this.modals.successModal = true;
                this.getPriceRate();
              }
            });
        }
      });
    },
    deleteWasteType(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value == true) {
          this.$http
            .delete(":10001/api/v1/setting-private/waste_type/" + id)
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                this.message = response;
                this.modals.successModal = true;
                this.getWasteTypeData();
                this.searchQueryWasteType = "";
              }
            });
        }
      });
    },
    deleteInventory(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value == true) {
          this.$http
            .delete(":10001/api/v1/setting-private/waste_sub_type/" + id)
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                this.message = response;
                this.modals.successModal = true;
                this.getInventory();
                this.searchQueryInventory = "";
              }
            });
        }
      });
    },
    getData(row) {
      this.inventory.images = [];
      this.flag = "edit";

      if (this.switches.pricerate == true) {
        this.pricerate.id = row.id;
        this.pricerate.item = row.id;
        this.pricerate.description = row.description;
        this.pricerate.price = row.price;
        this.modals.addnewpriceentry = true;
      }

      if (this.switches.concessionprice == true) {
        this.concessionprice.wastetypes = [];
        this.$http.get(":10001/api/v1/concession/" + row.id).then((res) => {
          if (!res.error) {
            let response = res.message;

            this.concessionprice.concessionid = response.concession_id;
            this.concessionprice.id = response.company_id;
            this.concessionprice.customer = response.company_name;
            this.concessionprice.expirydate = response.expired_date;

            for (var i = 0; i < response.wastes.length; i++) {
              let ws = {
                id: response.wastes[i].waste_concession_id,
                wastetype: response.wastes[i].waste_sub_type_id,
                price: response.wastes[i].price,
              };
              this.concessionprice.wastetypes.push(ws);
            }
          }

          this.modals.addconcessionprice = true;
        });
      }

      if (this.switches.inventorymgmt == true) {
        this.inventory.images = [];
        this.$http
          .get(":10001/api/v1/setting-private/waste_sub_type/" + row.id)
          .then((res) => {
            if (!res.error) {
              let response = res.message;

              this.inventory.images = [];

              this.inventory.id = response.waste_sub_type_id;
              this.inventory.wastetype = response.waste_type_id;
              this.inventory.item = response.name;
              this.inventory.description = response.description;
              this.inventory.servicelocation =
                response.service_location_id == 0
                  ? null
                  : response.service_location_id;
              this.inventory.isShow = response.show == false ? "Hide" : "Show";
              this.inventory.isShowPreprocessing =
                response.for_preprocessing == false ? "Hide" : "Show";
              this.inventory.isShowPostprocessing =
                response.for_postprocessing == false ? "Hide" : "Show";
              this.inventory.isSellableProduct =
                response.is_sellable == false ? "No" : "Yes";
              this.inventory.isHazardousSubstance =
                response.is_hazardous == false ? "No" : "Yes";
              this.inventory.isCorrosive =
                response.is_corrosive == false ? "No" : "Yes";

              // marshalling image
              this.inventory.images.push(response.image.url);
            }
          });

        this.modals.addInventoryMgmt = true;
      }

      if (this.switches.wastetypeproperties == true) {
        this.$http
          .get(":10001/api/v1/setting-private/waste_type/" + row.id)
          .then((res) => {
            if (!res.error) {
              let response = res.message;

              this.wastetypess.id = response.waste_type_id;
              this.wastetypess.name = response.name;
              this.wastetypess.description = response.description;
              this.wastetypess.isShow = response.show == true ? "Show" : "Hide";
              this.wastetypess.wasteorigin =
                response.for_vessel == true ? "Vessel" : "Land";

              this.modals.addwastetype = true;
            }
          });
      }

      if (this.switches.portmgmt == true) {
        console.log(row)
        this.port.servicelocations = [];
        this.$http
          .get(":10001/api/v1/setting-private/service_location/" + row.id)
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response)

              this.port.name = response[0].location;
              this.port.id = response[0].service_location_id;

              // marshall service location
              if (response[0].service_location_collection.length != 0) {
                for (
                  var i = 0;
                  i < response[0].service_location_collection.length;
                  i++
                ) {
                  let obj = {
                    id: response[0].service_location_collection[i]
                      .service_location_collection_id,
                    servicelocation:
                      response[0].service_location_collection[i].name,
                    type: response[0].service_location_collection[i].type,
                  };
                  this.port.servicelocations.push(obj);
                }
              }

              // marshall logo
              if(response[0].logo != null ){
                this.imageport = {
                  fileurl: response[0].logo.url,
                  fileid: response[0].logo.service_location_logo_id,
                };
              } else {
                this.imageport =  null;
              }
              
              this.modals.addportmgmt = true;
            }
          });
      }
    },
    downloadQR(data) {
      let description = data.description;
      let item = data.item;
      const image = new Image();
      image.src = require("@/assets/img/alam-flora.png");
      image.onload = () => {
        this.options = Object.assign({}, this.options, {
          logo: {
            image,
          },
        });
      };

      let doc = jsPDF({
        orientation: "potrait",
        format: [1070, 1240],
      });
      let QRs = [];
      QRs.push(
        QRCode.toDataURL(description)
          .then((url) => {
            let obj = {};
            obj["id"] = url;
            obj["description"] = description;
            obj["item"] = item;
            return obj;
          })
          .catch((err) => {
            console.error(err);
          })
      );

      Promise.all(QRs).then((QR) => {
        for (let i = 0; i < QR.length; i++) {
          let AssetNo = QR[i].item.split(" ");
          AssetNo.push(" ");
          AssetNo.push(" ");
          AssetNo.push(" ");
          AssetNo.push(" ");
          AssetNo.push(" ");

          var img = new Image();
          img.src = require("@/assets/img/alam-flora.png");
          doc.addImage(QR[i].id, "JPEG", -20, -20, 420, 420);

          doc.addImage(img, "JPEG", 30, 340, 90, 40);
          if (AssetNo.length < 3) {
            doc.text(AssetNo[0] + " " + AssetNo[1], 200, 380, "center");
          } else if (AssetNo.length < 5) {
            doc.text(AssetNo[0] + " " + AssetNo[1], 200, 380, "center");
            doc.text(AssetNo[2] + " " + AssetNo[3], 200, 390, "center");
          } else {
            let count = 380;
            for (var j = 0; j < AssetNo.length; j++) {
              if (j % 2 == 1) {
                doc.text(
                  AssetNo[j] + " " + AssetNo[j + 1],
                  200,
                  count,
                  "center"
                );
                count = count + 10;
              }
            }
          }
          if (i != QR.length - 1) {
            doc.addPage();
          }
        }
        doc.save(`QR.pdf`);
      });
    },
    onImagesChange(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.previewImage = e.target.result;
      };

      this.inventory.images = this.$refs.imageupload.files[0];
    },
    viewImage(row) {
      this.image = row.imageurl;
      this.modals.image = true;
    },
    addrow(flag) {
      if (flag == "concession") {
        this.concessionprice.wastetypes.push({
          wastetype: "",
          price: "",
        });
      }

      if (flag == "port") {
        this.port.servicelocations.push({
          servicelocation: "",
          type: "",
          id: 0,
        });
      }
    },
    menunoti(flag) {
      this.switches.pricerate = false;
      this.switches.concessionprice = false;
      this.switches.inventorymgmt = false;
      this.switches.wastetypeproperties = false;
      this.switches.portmgmt = false;
      if (flag == "pricerate") {
        this.switches.pricerate = true;
      }
      if (flag == "concessionprice") {
        this.switches.concessionprice = true;
      }
      if (flag == "inventorymgmt") {
        this.switches.inventorymgmt = true;
      }

      if (flag == "wastetypeproperties") {
        this.switches.wastetypeproperties = true;
      }

      if (flag == "portmgmt") {
        this.switches.portmgmt = true;
      }
    },
    getWasteSubType() {
      this.wastesubtypes = [];

      this.$http
        .get(":10001/api/v1/setting-private/waste_sub_type")
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            for (var i = 0; i < response.length; i++) {
              let obj = {
                label: response[i].name,
                value: response[i].waste_sub_type_id,
              };
              this.wastesubtypes.push(obj);
            }
          }
        });
    },
    getInventory() {
      this.inventorymgmts = [];
      this.inventorytemp = [];

      this.$http
        .get(":10001/api/v1/setting-private/waste_sub_type")
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            for (var i = 0; i < response.length; i++) {
              let obj = {
                id: response[i].waste_sub_type_id,
                item: response[i].name.split("-")[0],
                description:
                  response[i].description == "" ? "-" : response[i].description,
                servicelocation: response[i].location,
                lastedited: moment(response[i].last_updated).format(
                  "DD/MM/YYYY"
                ),
                imageurl: response[i].image.url,
              };
              this.inventorymgmts.push(obj);
              this.inventorytemp.push(obj);
            }

            if (this.searchQueryInventory != "") {
              let tempsearch = this.searchQueryInventory;
              this.searchQueryInventory = "";

              setTimeout(() => {
                this.searchQueryInventory = tempsearch;
              }, response.length);
            }
          }
        });
    },
  },
  created() {
    this.getPriceRate();
    this.getItems();
    this.getWasteType();
    this.getServiceLocation();
    this.getCustomer();
  },
  watch: {
    "pricerate.item"() {
      for (var i = 0; i < this.pricerate.items.length; i++) {
        if (this.pricerate.item == this.pricerate.items[i].value) {
          this.pricerate.description = this.pricerate.items[i].description;
        }
      }
    },
    "switches.pricerate"() {
      if (this.switches.pricerate == true) {
        this.getPriceRate();
      }
    },

    "switches.concessionprice"() {
      if (this.switches.concessionprice == true) {
        // special funtion sbb ada setting lain yang pakai dia
        this.getWasteSubType();

        this.getConcessionPriceRate();
      }
    },
    "switches.inventorymgmt"() {
      if (this.switches.inventorymgmt == true) {
        this.getInventory();
      }
    },
    "switches.wastetypeproperties"() {
      if (this.switches.wastetypeproperties == true) {
        this.getWasteTypeData();
      }
    },
    "switches.portmgmt"() {
      if (this.switches.portmgmt == true) {
        this.getPortData();
      }
    },
    searchQueryConcession: debounce(function (search) {
      if (search != "") {
        this.concessionprices = this.concessionpricestemp.filter((value) =>
          value.customer.toLowerCase().includes(search.toLowerCase())
        );
      } else {
        this.concessionprices = this.concessionpricestemp;
      }
    }, 500),
    searchQueryInventory: debounce(function (search) {
      if (search != "") {
        this.inventorymgmts = this.inventorytemp.filter(
          (value) =>
            value.item.toLowerCase().includes(search.toLowerCase()) ||
            value.description.toLowerCase().includes(search.toLowerCase())
        );
      } else {
        this.inventorymgmts = this.inventorytemp;
      }
    }, 500),
    searchPriceRate: debounce(function (search) {
      if (search != "") {
        this.pricerates = this.priceratestemp.filter(
          (value) =>
            value.item.toLowerCase().includes(search.toLowerCase()) ||
            value.description.toLowerCase().includes(search.toLowerCase())
        );
      } else {
        this.pricerates = this.priceratestemp;
      }
    }, 500),
    searchQueryWasteType: debounce(function (search) {
      if (search != "") {
        this.wastetypess.wastetypes = this.wastetypess.wastetypestemp.filter(
          (value) =>
            value.wastetype.toLowerCase().includes(search.toLowerCase()) ||
            value.description.toLowerCase().includes(search.toLowerCase()) ||
            value.origin.toLowerCase().includes(search.toLowerCase())
        );
      } else {
        this.wastetypess.wastetypes = this.wastetypess.wastetypestemp;
      }
    }, 500),
    searchQueryPortMgmt: debounce(function (search) {
      if (search != "") {
        this.ports = this.portstemp.filter((value) =>
          value.port.toLowerCase().includes(search.toLowerCase())
        );
      } else {
        this.ports = this.portstemp;
      }
    }, 500),
  },
};
</script>

<style scoped>
.custom-title {
  color: #000000;
  font-weight: 600;
  font-size: 20px;
}

.custom-desc {
  color: #afadad;
  font-size: 14px;
}

.custom-card {
  margin-bottom: 2%;
  margin-top: 2%;
  background: #f5f6fa;
  border-radius: 8px;
  padding: 5%;
}

.custom-value {
  border: none;
  color: #000000;
  font-size: 20px;
  font-weight: 600;
  border-bottom: 1px solid #cecece;
  width: 40%;
  background-color: transparent;
}

.custom-value:active {
  border: 0;
  border-bottom: 1px solid #cecece;
  background-color: transparent;
}

.custom-value:hover {
  border: 0;
  border-bottom: 1px solid #cecece;
  background-color: transparent;
}
.custom-value:target {
  border: 0;
  border-bottom: 1px solid #cecece;
  background-color: transparent;
}

.custom-value:focus {
  border: 0;
  border-bottom: 1px solid #cecece;
  background-color: transparent;
}

.custom-select2 {
  border: none;
  border-radius: 20px !important;
  background-color: #ffffff !important;
  color: #a09f9f;
  border: 1px solid #00000029;
  width: 45%;
  height: 35px;
  font-weight: bold;
  font-size: 12px;
  padding-left: 14px !important;
  padding-right: 5px !important;

  background: url("data:image/svg+xml;utf8,<svg fill='green'  height='48' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>")
    no-repeat right #368dcc;
  -webkit-appearance: none;
  background-position-x: 150px;
}

.custom-select2:active {
  border: none;
}

.custom-option2 {
  background-color: #ffffff;
  color: #a09f9f;
  font-size: 12px;
}

.timeselectclass {
  background-color: pink !important;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}

.el-table .cell {
  word-break: break-word !important;
}
</style>
